import {GLOW_THREAD} from '../../configs/glowingThreads';

/**
 * Геометрия светящейся нити: ломаная по центрам ячеек. Только расчет: рисует
 * scenes/GlowingThreads, летящие по пути шары берет utils/effects/buildAbilityCast.
 */

/**
 * @param {Array<{x: number, y: number}>} points
 * @returns {{points: Object[], segments: Object[], length: number}} отрезки с началом,
 *   углом, длиной и расстоянием от начала нити (start). Нулевые отрезки выброшены
 */
export const buildThreadGeometry = (points) => {
  const segments = [];
  let length = 0;
  (points || []).slice(1).forEach((point, index) => {
    const from = points[index];
    const segmentLength = Math.hypot(point.x - from.x, point.y - from.y);
    if (segmentLength > 0) {
      segments.push({
        x: from.x,
        y: from.y,
        angle: Math.atan2(point.y - from.y, point.x - from.x),
        length: segmentLength,
        start: length,
      });
      length += segmentLength;
    }
  });
  return {points: points || [], segments, length};
};

/**
 * Точка нити на расстоянии от ее начала (за пределами нити — ее концы)
 * @returns {{x: number, y: number}}
 */
export const resolveThreadPoint = ({points, segments, length}, distance) => {
  if (segments.length === 0) {
    return {x: points[0]?.x ?? 0, y: points[0]?.y ?? 0};
  }
  const clamped = Math.min(length, Math.max(0, distance));
  const segment = segments.find(({start, length: segmentLength}) => clamped <= start + segmentLength)
    || segments[segments.length - 1];
  const along = clamped - segment.start;
  return {
    x: segment.x + Math.cos(segment.angle) * along,
    y: segment.y + Math.sin(segment.angle) * along,
  };
};

/** За сколько нить дотягивается до конца: длинному пути больше, но в пределах */
export const resolveThreadRevealMs = (length, hexSize) => {
  const {revealMsPerHexSize, minRevealMs, maxRevealMs} = GLOW_THREAD;
  const cells = hexSize > 0 ? length / hexSize : 0;
  return Math.min(maxRevealMs, Math.max(minRevealMs, Math.round(cells * revealMsPerHexSize)));
};
